var map = {
	"./Astronaut 1.png": 1031,
	"./Ellipse.png": 1032,
	"./Hero-Security.png": 1033,
	"./arrow-down-blue.svg": 474,
	"./arrow-down-grey.svg": 475,
	"./arrow-right-white.png": 1034,
	"./arrow-right.svg": 476,
	"./avax-logo.png": 330,
	"./binance-logo.png": 331,
	"./blue-loader.svg": 71,
	"./circle-grey.svg": 234,
	"./circle.svg": 235,
	"./coinbaseWalletIcon.svg": 155,
	"./coingecko.png": 1035,
	"./coinmarketcap.png": 1036,
	"./crosschain/AAVE.png": 502,
	"./crosschain/AVAX.png": 503,
	"./crosschain/Army.png": 504,
	"./crosschain/BIOS.png": 505,
	"./crosschain/BNB.png": 506,
	"./crosschain/BUSD.png": 507,
	"./crosschain/CHART.png": 508,
	"./crosschain/CNR.png": 509,
	"./crosschain/CRO.png": 238,
	"./crosschain/CRYSTL.png": 510,
	"./crosschain/DXP.png": 511,
	"./crosschain/ESW.png": 512,
	"./crosschain/ESW.svg": 236,
	"./crosschain/ETH.png": 513,
	"./crosschain/FTM.png": 239,
	"./crosschain/GDL.png": 514,
	"./crosschain/GLMR.png": 240,
	"./crosschain/GROW.png": 515,
	"./crosschain/HT.png": 516,
	"./crosschain/HTZ.png": 241,
	"./crosschain/INDA.png": 517,
	"./crosschain/IOTX.png": 242,
	"./crosschain/LINK.png": 518,
	"./crosschain/LUDUS.png": 519,
	"./crosschain/MAI.png": 520,
	"./crosschain/MATIC.png": 521,
	"./crosschain/METIS.png": 243,
	"./crosschain/MOVR.png": 244,
	"./crosschain/MTV.png": 245,
	"./crosschain/OKT.png": 246,
	"./crosschain/ONE.png": 247,
	"./crosschain/PERA.png": 522,
	"./crosschain/RELAY.png": 299,
	"./crosschain/SDN.png": 248,
	"./crosschain/SUSHI.png": 523,
	"./crosschain/TUSD.png": 249,
	"./crosschain/UNI.png": 524,
	"./crosschain/WAS.png": 525,
	"./crosschain/WETH.png": 526,
	"./crosschain/WISB.png": 527,
	"./crosschain/XCAD.png": 250,
	"./crosschain/XIOT.png": 528,
	"./crosschain/YFI.png": 529,
	"./crosschain/ZERO.png": 530,
	"./crosschain/heco-icon.png": 531,
	"./crosschain/wBTC.png": 532,
	"./crosschain/wDAI.png": 533,
	"./crosschain/wUSDC.png": 534,
	"./crosschain/wUSDT.png": 535,
	"./crosschain/z1INCH.png": 536,
	"./crosschain/zBTC.png": 537,
	"./crosschain/zDAI.png": 538,
	"./crosschain/zETH.png": 539,
	"./crosschain/zUSDC.png": 540,
	"./crosschain/zUSDT.png": 541,
	"./discord.svg": 477,
	"./dropdown-blue.svg": 478,
	"./dropdown-white-select.svg": 479,
	"./dropdown.svg": 480,
	"./dropup-blue.svg": 481,
	"./ethereum-logo.png": 332,
	"./flare 1.png": 1037,
	"./fortmaticIcon.png": 191,
	"./heco-icon.jpg": 333,
	"./ht.png": 1038,
	"./link.svg": 482,
	"./logo-text-white.png": 1039,
	"./logo-zero-124.png": 1040,
	"./logo-zero-512.png": 1041,
	"./magnifying-glass.svg": 483,
	"./matic-logo.png": 1042,
	"./menu.svg": 484,
	"./metamask-icon.svg": 485,
	"./metamask.png": 336,
	"./new-design/Astronaut 1.png": 1043,
	"./new-design/Ellipse 116.png": 1044,
	"./new-design/Ellipse 118.png": 1045,
	"./new-design/Ellipse 120.png": 1046,
	"./new-design/Ellipse.png": 1047,
	"./new-design/Frame.svg": 300,
	"./new-design/Hero-Security.png": 1048,
	"./new-design/RELAY12 1.png": 1049,
	"./new-design/academy/avax_to_harm.png": 1050,
	"./new-design/academy/metamask_in_ava.png": 1051,
	"./new-design/academy/movr_to_ava.png": 1052,
	"./new-design/academy/usdt_to_shiden.png": 1053,
	"./new-design/arrow-left.svg": 486,
	"./new-design/arrow-right.svg": 487,
	"./new-design/background ellipse.png": 1054,
	"./new-design/fail.png": 543,
	"./new-design/flare 1.png": 1055,
	"./new-design/partners/canary.png": 1056,
	"./new-design/partners/iotex.png": 1057,
	"./new-design/partners/mcn.png": 1058,
	"./new-design/partners/moonbeam.png": 1059,
	"./new-design/partners/quickswap.png": 1060,
	"./new-design/partners/solarbeam.png": 1061,
	"./new-design/relay-academy.png": 1062,
	"./new-design/relay-name.png": 1063,
	"./new-design/spaceman1.png": 1064,
	"./new-design/spaceman2.png": 1065,
	"./new-design/spaceship.png": 544,
	"./new-design/success-old.png": 1066,
	"./new-design/success.png": 1067,
	"./new-design/video-block.png": 1068,
	"./new-design/wallet.png": 545,
	"./new-design/warning.svg": 488,
	"./outside-link.svg": 489,
	"./plus-blue.svg": 490,
	"./plus-grey.svg": 491,
	"./polkadot-logo.png": 334,
	"./polygon-logo.png": 335,
	"./portisIcon.png": 192,
	"./question-mark.svg": 492,
	"./question.svg": 493,
	"./reddit.svg": 494,
	"./relay-icon.png": 329,
	"./relay-name.png": 1069,
	"./small-dropdown-white-select.svg": 237,
	"./space-bg.png": 1070,
	"./spaceman1.png": 1071,
	"./spaceman2.png": 1072,
	"./spinner.svg": 495,
	"./telegram.svg": 496,
	"./token-list/lists-dark.png": 1073,
	"./token-list/lists-light.png": 1074,
	"./token-logo.png": 145,
	"./trustWallet.png": 1075,
	"./video-block.png": 1076,
	"./walletConnectIcon.svg": 156,
	"./x.svg": 497
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 302;